<template>
	<div>
		<span class="flex justify-evenly" @click="onClick()">
			<span style="padding-left: 4px">{{ displayValue }}</span>
			<span :title="$t('Edit')" style="height: 30px">🖉</span>
		</span>
	</div>
</template>

<script>
export default {
	data() {
		return {
			displayValue: "",
		};
	},
	beforeMount() {
		this.displayValue = this.params.value;
	},
	methods: {
		onClick() {
			this.params.api.startEditingCell({
				rowIndex: this.params.rowIndex,
				colKey: this.params.column.getId(),
			});
		},
	},
};
</script>
